// Conexoes que o usuario pode ver. So o Administrador ve todas; quem tem
// conexoes marcadas no cadastro ("Conexao Padrao") ve so as conversas delas.
// Sem nenhuma marcada, nao restringe. Mesma regra do backend
// (ListTicketsService): o servidor ja filtra a lista ao carregar, e este
// filtro cobre o que chega ao vivo pelo socket (mensagem nova, conversa nova,
// notificacao), que e enviado para todos os usuarios da empresa.

export const conexoesDoUsuario = (user) => {
  const tipo = String(user?.userType || "").toLowerCase();
  if (tipo === "admin" || tipo === "administrador") return [];
  return [
    ...(Array.isArray(user?.whatsapps) ? user.whatsapps.map((w) => Number(w.id)) : []),
    ...(user?.whatsappId ? [Number(user.whatsappId)] : []),
  ].filter(Boolean);
};

export const ticketEhDasMinhasConexoes = (user, ticket) => {
  const minhas = conexoesDoUsuario(user);
  if (!minhas.length) return true;
  const conexao = Number(ticket?.whatsappId || ticket?.whatsapp?.id);
  return !conexao || minhas.includes(conexao);
};
